import { useEffect, useRef, useContext, createElement } from '@max/max';
export default function VideoPlayer(props) {
    const { autoplay, loop, mute, poster, videoUrl, autoSize, videoWidth, videoHeight } = props;
    const videoRef = useRef(null);
    const isFirstRef = useRef(true);
    const ua = navigator.userAgent;
    const isWeixin = ua.indexOf('MicroMessenger') > 0;
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
    const ctx = useContext(global._EngineGlobalContext);
    const onPlayerStatusChange = () => {
        let video = document.getElementById('videoHtml');
        if (video && video.paused) {
            video.play();
        }
        else {
            video.pause();
        }
    };
    useEffect(() => {
        console.log('ua', ua);
        if (autoplay) {
            // 安卓触摸屏后播放
            console.log('安卓', isAndroid, '微信', isWeixin);
            if (isWeixin) {
                document.addEventListener('touchstart', function () {
                    console.log('微信内播放');
                    if (isFirstRef.current) {
                        isFirstRef.current = false;
                        return;
                    }
                    let video = document.getElementById('videoHtml');
                    if (video) {
                        video.play();
                    }
                }, false);
            }
        }
    }, []);
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('mcp-component-head-video-play', onPlayerStatusChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('mcp-component-head-video-play', onPlayerStatusChange);
        };
    }, [onPlayerStatusChange]);
    return <video id="videoHtml" playsInline // iOS 内联播放
     webkit-playsinline="true" x5-playsinline="true" x-webkit-airplay="allow" preload="auto" controls={false} // 隐藏默认控件
     style={{
        width: autoSize ? '750rpx' : `${videoWidth}rpx`,
        height: autoSize ? `${videoWidth * 9 / 16}rpx` : videoHeight ? `${videoHeight}rpx` : `${videoWidth * 9 / 16}rpx`,
        objectFit: 'cover',
        // 视频填充方式
        WebkitAppearance: 'none',
        // 移除 webkit 默认样式
        outline: 'none' // 移除点击时的轮廓
    }} ref={videoRef} src={videoUrl} poster={poster} muted={mute} loop={loop} autoPlay={autoplay && !isWeixin}/>;
}
